import React, { useState, useEffect } from "react";

import { ScrollToTopButton } from "./ToTopButton.elements";

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    const element = document.getElementById("filters");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <ScrollToTopButton onClick={scrollToTop} show={showButton}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.41058 12.7439C4.16651 12.4998 4.16651 12.1038 4.41058 11.8598L9.41058 6.85975C9.65466 6.61567 10.0506 6.61567 10.2947 6.85975L15.2947 11.8598C15.5388 12.1038 15.5388 12.4998 15.2947 12.7439C15.0506 12.9879 14.6547 12.9879 14.4106 12.7439L9.85264 8.18587L5.29467 12.7439C5.05059 12.9879 4.65466 12.9879 4.41058 12.7439Z"
          fill="white"
        />
      </svg>
    </ScrollToTopButton>
  );
};

export default ScrollToTop;
